import styled from 'styled-components';

const Base = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding: ${(props) => props.theme.padding.default};
  box-sizing: border-box;
`;

const Frame = {
  Base,
};

export default Frame;
